import React from 'react'

export default function Approvals() {
  return (
    <div>Approvals</div>
  )
}
